/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var util_1 = require("./util");

var SessionStorage = /*#__PURE__*/function () {
  function SessionStorage() {
    _classCallCheck(this, SessionStorage);
  }

  _createClass(SessionStorage, null, [{
    key: "getItem",
    value: function getItem(key) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var item = this._get(key);

      if (item && opts.json) {
        try {
          return JSON.parse(item);
        } catch (e) {
          console.error("Error parsing JSON returned at '".concat(key, "' from sessionStorage"), item);
        }
      }
    }
  }, {
    key: "_get",
    value: function _get(key) {
      return sessionStorage.getItem(key);
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (opts.json) {
        try {
          value = JSON.stringify(value);
        } catch (e) {
          console.error("Error stringifying value '".concat(value, " at ").concat(key, " for seesionStorage"));
        }
      }

      this._set(key, value);
    }
  }, {
    key: "_set",
    value: function _set(key, value) {
      sessionStorage.setItem(key, value);
    }
  }]);

  return SessionStorage;
}();

if (util_1.isReactNative()) {}

exports.default = SessionStorage;